import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {CbInfiniteScrollModule} from '../../directives/infinite-scroll/infinite-scroll.module';
import {CbDasherModule} from '../../pipe/dasher/dasher.module';
import {CbInfoMessageModule} from '../info-message/info-message.module';
import {CbInfoPopupModule} from '../info-popup/info-popup.module';
import {CbLoadingSpinnerModule} from '../loading-spinner/loading-spinner.module';
import {CB_TABLE_EXPORTS} from './exports';

const COMPONENTS = [
    ...CB_TABLE_EXPORTS,
];

@NgModule({
    declarations: [
        COMPONENTS
    ],
    imports: [
        CommonModule,
        MatDividerModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        CbInfoPopupModule,
        CbDasherModule,
        CbInfoMessageModule,
        MatSelectModule,
        MatCardModule,
        MatCheckboxModule,
        CbLoadingSpinnerModule,
        MatTableModule,
        InfiniteScrollDirective,
        CbInfiniteScrollModule,
    ],
    exports: COMPONENTS,
})
export class CbTableModule {
}
